import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import zh_CN from './locales/zh/translation.json';
import zh_TW from './locales/zh-TW/translation.json';
import en from './locales/en/translation.json';
import ja from './locales/ja/translation.json';
import fr from './locales/fr/translation.json';
import es from './locales/es/translation.json';
import ko from './locales/ko/translation.json';

// 获取浏览器语言设置
const getBrowserLanguage = () => {
  const browserLang = navigator.language.toLowerCase();
  // 将浏览器语言代码转换为全称
  const langMap = {
    'zh-cn': 'zh-CN',
    'zh-tw': 'zh-TW',
    'zh-hk': 'zh-TW',
    'zh': 'zh-CN',
    'en': 'english',
    'ja': 'japanese',
    'fr': 'french',
    'es': 'spanish',
    'ko': 'korean'
  };
  const fullLang = langMap[browserLang] || 'english';
  // 检查是否支持该语言
  const supportedLanguages = ['zh-CN', 'zh-TW', 'english', 'japanese', 'french', 'spanish', 'korean'];
  return supportedLanguages.includes(fullLang) ? fullLang : 'english';
};

i18n
  .use(initReactI18next)
  .init({
    resources: {
      'zh-CN': { translation: zh_CN },
      'zh-TW': { translation: zh_TW },
      'english': { translation: en },
      'japanese': { translation: ja },
      'french': { translation: fr },
      'spanish': { translation: es },
      'korean': { translation: ko }
    },
    lng: getBrowserLanguage(),
    fallbackLng: 'english',
    interpolation: { escapeValue: false }
  });

export default i18n;